import React from 'react';
import './Footer.scss';
import { useTranslation } from "react-i18next";
import ContactUs from '../ContactUs/ContactUs';

function Footer() {
    const { t } = useTranslation();
    let year = new Date().getFullYear();
    let footerText = t(`Footer.copy`);
    let indexofCopyRight = footerText?.indexOf('©');
    let newFooterText = footerText?.replace(footerText?.charAt(indexofCopyRight+1),` ${year} `);
    return (
        <div className='footer'>
          <p className="copy">{newFooterText}</p>
          <ContactUs />
        </div>
    );
}

export default Footer;
